import React, { useState } from 'react';
import PropTypes from 'prop-types';

const Accordion = ({ accordionData }) => {
  const [activeIndex, setActiveIndex] = useState(0);

  const toggleAccordion = (index) => {
    if (activeIndex === index) {
      setActiveIndex(null);
    } else {
      setActiveIndex(index);
    }
  };

  return (
    <div className="accordion">
      {accordionData?.map((item, index) => (
        <div key={index} className="accordion-item">
          <div
            className="accordion-header"
            onClick={() => toggleAccordion(index)}
          >
            {item.question}
          </div>
          {activeIndex === index && (
            <div className="accordion-content">
              <p>{item.answer}</p>
            </div>
          )}
        </div>
      ))}
    </div>
  );
};

Accordion.defaultProps = {
  accordionData: [],
};

Accordion.propTypes = {
  accordionData: PropTypes.array,
};

export default Accordion;
